import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { AlertBasicConfirmDialogComponent } from '../../../../shared/components/alert-basic-confirm-dialog/alert-basic-confirm-dialog.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { IonToggle, IonItem, IonLabel } from '@ionic/angular/standalone';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { NativeBluetoothService } from '../../../../core/services/bluetooth/native-bluetooth.service';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-ble-activate-dialog',
  standalone: true,
  imports: [IonToggle, IonItem, IonLabel, MatSlideToggleModule, FormsModule, MatIconModule],
  templateUrl: './ble-activate-dialog.component.html',
  styleUrl: './ble-activate-dialog.component.scss'
})
export class BleActivateDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<AlertBasicConfirmDialogComponent>,
    private bluetoothService: NativeBluetoothService
  ) {}

  bluetoothActivo: boolean = false;

  async onBleToogleChange(event: CustomEvent) {
    if (Capacitor.getPlatform() === 'ios') {
      this.bluetoothActivo = await this.bluetoothService.enableBle();
      return;
    }

    if (this.bluetoothActivo) {
      const actived = await this.bluetoothService.enableBle();

      if (!actived) {
        setTimeout(() => (this.bluetoothActivo = false), 100);
      }
    } else {
      await this.bluetoothService.disableBle();
    }
  }

  onConfirmClick() {
    this.dialogRef.close('confirm');
  }

  onNoClick(): void {
    this.dialogRef.close('cancel');
  }
}
